/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import FreeUsersRestApi from './free-users-rest-api.service';
export {FreeUsersRestApi};
